module.exports = __webpack_public_path__ + "img/Najarian.902fa157.jpg";